import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useData } from '../context/DataContext';
import { useT } from '../context/LanguageContext';

const AI_PAGES = new Set([
  'diagnose', 'advertentie', 'ai-foutcode', 'ai-offerte',
  'oh-nieuw', 'oh-waardebepaling', 'oh-advertenties',
  'oh-voorraad', 'oh-gebruikt', 'oh-sloop',
]);

export default function AiKeyBanner({ activePage, onNavigate }) {
  const { t } = useT();
  const { gegevens } = useData();
  if (!AI_PAGES.has(activePage)) return null;
  if (gegevens?.geminiKeySet) return null;

  const go = () => {
    try { sessionStorage.setItem('mc_open_settings_tab', 'licentie'); } catch (e) { /* noop */ }
    if (onNavigate) onNavigate('instellingen');
  };

  return (
    <div data-testid="ai-key-banner" style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', margin: '0 0 16px', padding: '12px 16px', background: 'var(--cs-amber-soft, #fef3c7)', border: '1px solid var(--cs-amber, #d97706)', borderRadius: 10, color: 'var(--cs-amber, #92400e)' }}>
      <Sparkles size={18} style={{ flexShrink: 0 }} />
      <span style={{ fontSize: 13.5, fontWeight: 600, flex: 1, minWidth: 200 }}>
        {t('Stel eerst je gratis Google Gemini API-sleutel in om de AI-functies te gebruiken.', 'Stel eerst je gratis Google Gemini API-sleutel in om de AI-functies te gebruiken.')}
      </span>
      <button data-testid="ai-key-banner-cta" onClick={go} className="cs-btn primary" style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {t('Sleutel instellen', 'Sleutel instellen')} <ArrowRight size={14} />
      </button>
    </div>
  );
}
